import Head from 'next/head';
import Alerts from '@/components/Alerts';
import { AlertsCode } from '@/components/codeHighlights/AlertsCode';

const AlertsPage = () => {
  return (
    <>
      <Head>
        <title>Alerts</title>
      </Head>

      <h1>Alerts</h1>
      <div className="mt-5">
        <Alerts />
      </div>
      <div className="mt-5">
        <h2>Alert HTML-Code Example</h2>
        <AlertsCode />
      </div>
    </>
  );
};

export default AlertsPage;
